module.exports = __webpack_public_path__ + "static/media/choice_appear.c6eba89d.mp3";